export default "__VITE_ASSET__DKXK8qo1__"